/* V2 cards: complete Variant option tuple reaches the existing Theme controller. */
(() => {
  if (window.__csV2SelectorCardsBound) return;
  window.__csV2SelectorCardsBound = true;

  const restoreCurrentRadio = (picker, attemptedRadio) => {
    // ProductInfo updates this native form input only after its section request
    // succeeds. The SSR data attribute is a fallback for Theme contexts without
    // that form; it must never override an existing form with an empty ID.
    const form = document.getElementById(`product-form-${picker.dataset.section}`);
    const formVariantInput = form?.querySelector('input[name="id"]');
    const currentVariantId = formVariantInput
      ? formVariantInput.value
      : picker.dataset.csV2CurrentVariantId;
    attemptedRadio.checked = false;
    const currentRadio = Array.from(picker.querySelectorAll('[data-cs-v2-card-radio]'))
      .find((input) => input.dataset.csV2VariantId === currentVariantId);
    if (currentRadio) currentRadio.checked = true;
  };

  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || !radio.matches('[data-cs-v2-card-radio]')) return;
    const picker = radio.closest('variant-selects[data-cs-v2-picker]');
    if (!picker) return;

    let values;
    try {
      values = JSON.parse(radio.dataset.csV2OptionValues || 'null');
    } catch (_) {
      values = null;
    }
    const selects = Array.from(picker.querySelectorAll('select[data-cs-v2-option-index]'));
    const finalId = radio.dataset.optionValueId;
    const expectedCount = selects.length + 1;
    const matches = Array.isArray(values) && values.length === expectedCount && finalId &&
      values[values.length - 1] === radio.value &&
      selects.every((select, index) => {
        const choice = Array.from(select.options).find((option) => option.value === values[index]);
        return choice && choice.dataset.optionValueId;
      });

    if (!matches) {
      // Keep the previous purchasable Variant and let the original Theme state stand.
      event.stopImmediatePropagation();
      restoreCurrentRadio(picker, radio);
      console.error('CS V2 selector: incomplete Variant option tuple');
      return;
    }

    // Set every preceding dimension before VariantSelects reads selectedOptionValues.
    // Its one native change event then refreshes URL, price, image and both forms.
    const previousSelections = selects.map((select) => select.value);
    selects.forEach((select, index) => {
      const choice = Array.from(select.options).find((option) => option.value === values[index]);
      select.value = choice.value;
      Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
      choice.setAttribute('selected', 'selected');
    });

    const selectedIds = Array.from(picker.querySelectorAll('select option[selected], fieldset input:checked'))
      .map((input) => input.dataset.optionValueId);
    if (selectedIds.length !== expectedCount || selectedIds.some((id) => !id)) {
      event.stopImmediatePropagation();
      selects.forEach((select, index) => {
        select.value = previousSelections[index];
        Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
        const previous = Array.from(select.options).find((option) => option.value === previousSelections[index]);
        if (previous) previous.setAttribute('selected', 'selected');
      });
      restoreCurrentRadio(picker, radio);
      console.error('CS V2 selector: native option value IDs incomplete');
    }
  }, true);
})();

/* Keep native sticky axes on a complete selection-card tuple before native commerce runs. */
(() => {
  if (window.__csSelectionStickyTupleBound) return;
  window.__csSelectionStickyTupleBound = true;
  document.addEventListener('change', (event) => {
    const changed = event.target;
    if (!(changed instanceof HTMLSelectElement)) return;
    const sticky = changed.closest('variant-selects[data-sticky]');
    const primary = sticky?.closest('product-info')?.querySelector('variant-selects[data-primary]');
    if (!primary || (!primary.hasAttribute('data-cs-v2-picker') && !primary.hasAttribute('data-cs-stage1-picker'))) return;
    const selects = Array.from(sticky.querySelectorAll('select'));
    const axis = selects.indexOf(changed);
    if (axis < 0) return;
    const selected = selects.map((select) => select.value);
    let tuples = [];
    if (primary.hasAttribute('data-cs-stage1-picker')) {
      try {
        const data = JSON.parse(primary.querySelector('[data-cs-stage1-tuples]').textContent);
        if (Array.isArray(data)) tuples = data.map((entry) => entry.options);
      } catch (_) {}
    } else {
      tuples = Array.from(primary.querySelectorAll('[data-cs-v2-card-radio]')).flatMap((radio) => {
        try { return [JSON.parse(radio.dataset.csV2OptionValues || 'null')]; }
        catch (_) { return []; }
      });
    }
    tuples = tuples.filter((values) => Array.isArray(values) && values.length === selects.length);
    const validChoices = (tuple) => tuple.map((value, index) =>
      Array.from(selects[index].options).find((option) => option.value === value && option.dataset.optionValueId));
    const candidates = tuples.filter((tuple) => tuple.slice(0, axis + 1).every((value, index) => value === selected[index]) && validChoices(tuple).every(Boolean));
    const tuple = candidates.find((values) => values.every((value, index) => value === selected[index])) || candidates[0];
    if (!tuple) {
      event.stopImmediatePropagation();
      try {
        const current = JSON.parse(primary.querySelector('[data-selected-variant]').textContent);
        const choices = validChoices(current.options);
        if (current.options.length === selects.length && choices.every(Boolean)) {
          selects.forEach((select, index) => {
            select.value = choices[index].value;
            Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
            choices[index].setAttribute('selected', 'selected');
          });
        }
      } catch (_) {}
      return;
    }
    const choices = validChoices(tuple);
    selects.forEach((select, index) => {
      select.value = choices[index].value;
      Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
      choices[index].setAttribute('selected', 'selected');
    });
  }, true);
})();
